<template>
  <div class='page-wrap' :class='device=="mobile"?"mobile":""'>
    <nav-bar></nav-bar>
    <div class="app-container" v-loading='pageLoading'>
      <div class='theader'>
        <p>区块详情</p>
      </div>
      <div class="page-sec">
        <template v-if='info && list && list.length>0'>
          <div class='content-sec'>
            <div class="common-row"><span class='key'>区块高度：</span><span class='value'>{{ $route.query.key }}</span></div>
            <div class="common-row"><span class='key'>区块哈希：</span><span class='value'>{{ info.blockHash }}</span><span class="copy-btn" :data-clipboard-text="info.blockHash" @click='copyFn'></span></div>
            <div class="common-row"><span class='key'>交易数量：</span><span class='value'>{{ total }}</span></div>
            <div class="common-row"><span class='key'>区块生成时间：</span><span class='value'>{{ info.indate }}</span></div>
            <div v-if="Number($route.query.key) && $route.query.key>1" class="common-row"><span class='key'>上一区块：</span><span class='value link-type' @click='$router.push({ name: "block", query: { key: Number($route.query.key)-1 } })'>{{ Number($route.query.key)-1 }}</span></div>
            <div v-if='Number($route.query.key)' class="common-row"><span class='key'>下一区块：</span><span class='value link-type' @click='$router.push({ name: "block", query: { key: Number($route.query.key)+1 } })'>{{ Number($route.query.key)+1 }}</span></div>
          </div>
        </template>
        <el-row v-else type='flex' justify="center" style='width: 100%;'>
          <el-empty :image-size="100" description="暂未找到您所查询的内容，请重新查询"></el-empty>
        </el-row>
      </div>
      <div class='theader'>
        <p>交易信息</p>
      </div>
      <template v-if='info && list && list.length>0'>
        <!-- 表格 -->
        <el-table
          ref='table'
          :key="tableKey"
          v-loading="listLoading"
          :data="list"
          fit
          highlight-current-row
          :size='device=="mobile"?"mini":""'
          style="width: 100%;"
        >
          <!-- <el-table-column label="ID" align="center" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="交易哈希" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class='link-type' @click='$router.push({ name: "trade", query: { key: scope.row.transactioHash} })'>{{ scope.row.transactioHash }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发送账户" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class='link-type' @click='transAddr(scope.row.fromAddress)'>{{ scope.row.fromAddress }}</span>
            </template>
          </el-table-column>
          <el-table-column label="接收账户" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class='link-type' @click='transAddr(scope.row.toAddress)'>{{ scope.row.toAddress }}</span>
            </template>
          </el-table-column>
          <el-table-column label="主资产编号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="">{{ scope.row.mainId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="子资产编号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="">{{ scope.row.subId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易订单号" align="center" width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="">{{ scope.row.transactionOrderId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易时间" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.transactionTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易状态" align="center" width="100">
            <template slot-scope="scope">
              <span :class='scope.row.transactioState===0?"text-gray":scope.row.transactioState===1?"text-green":""'>{{ scope.row.transactioState===0?"等待确认":scope.row.transactioState===1?"交易成功":"" }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination v-if='device!="mobile"' v-show="total>0" :current-page="Math.floor(listQuery.skipCount/listQuery.maxResultCount)+1" :page-sizes="[10,15,30, 50]" :page-size="listQuery.maxResultCount" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
          <el-pagination
            v-else
            small
            layout="prev, pager, next"
            :total="total"
             @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </template>

      <div v-else class="page-sec">
        <el-row type='flex' justify="center" style='width: 100%;'>
          <el-empty :image-size="100" description="暂未找到您所查询的内容，请重新查询"></el-empty>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import { main } from '@/api/block'
import { Mixin } from '@/utils/mixin.js'
import { mapGetters } from 'vuex'

export default {
  name: 'trade',
  mixins: [ Mixin ],
  data() {
    return {
      info: null,
      tableKey: 0,
      list: null,
      total: null,
      pageLoading: false,
      listLoading: false,
      freshLoading: false,
      downLoading: false,
      showSearch: true,
      listQuery: {
        maxResultCount: 10,
        skipCount: 0,
        blockHeight: this.$route.query.key,
      },
    }
  },
  created() {
    if(this.cacheData) {
      this.reqCb(this.cacheData)
      this.$store.dispatch('app/cacheData', null)
      return;
    }
    this.fetchList()
  },
  computed: {
    ...mapGetters([
      'cacheData'
    ]),
  },
  mounted() {
  },
  methods: {
    fetchList() {
      this.pageLoading = true
      main(this.listQuery).then(response => {
        const { data } = response
        if(!data) return;
        this.reqCb(data)
      }).catch(() => {
        this.pageLoading = false
      })
    },
    reqCb(data) {
      let { blockHash, indate, transactionDetails: { items, totalCount } } = data
      this.info = data
      this.list = items
      this.total = totalCount
      this.pageLoading = false
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">

  
</style>
